export default __webpack_public_path__ + "static/media/ic-instruction-13.1908b2e5.svg";